import { IPercentIsEmptyLang } from '../../../types/lang'
import { EPercentIsEmpty } from '../../../types'

export const percentIsEmptyLang: IPercentIsEmptyLang = {
	percent_is_empty: {
		[EPercentIsEmpty.NotEmpty]: 'Not Empty',
		[EPercentIsEmpty.Empty]: 'Empty',
	}
}